import React, { FC } from 'react'
import Strings from 'project/localisation'
import Link from 'next/link'
import imageResize from 'project/image-proxy-web'

type OtherCommunityType = {
  slug: string
  title: string
}

type OtherCommunityPagesType = {
  items: OtherCommunityType[]
}

const OtherCommunityPages: FC<OtherCommunityPagesType> = ({ items }) => {
  return (
    <div className={'other-community-pages bg-grey6 pt-lg-21 pt-14 pb-6'}>
      <div className='container text-center'>
        <h2 className={'text-semibold'}>
          {Strings.checkOutOurOtherCommunityPages}
        </h2>
        <div className='row mt-lg-13 mt-14 px-xxl-24 justify-content-center'>
          {items.map((item) => {
            return (
              <Link
                key={item.slug}
                className='col-lg-4 cursor-pointer px-lg-2 px-5 mb-lg-0 mb-4 a-unstyled'
                href={`/${item.slug}`}
              >
                <div className='other-community-pages__item'>
                  <div className={'img-container'}>
                    <img
                      loading='lazy'
                      className={'img-fluid'}
                      alt={item.title}
                      src={imageResize(
                        require(`public/images/other-community/${item.slug}.png`),
                      )}
                    />
                  </div>
                  <h4 className={'text-semibold p-xl-6 px-2 py-6'}>
                    {item.title}
                  </h4>
                </div>
              </Link>
            )
          })}
        </div>
      </div>
    </div>
  )
}

export default OtherCommunityPages
